import Base from './base'
import { accessoryMap } from '@/services/assets'

export default {
  get () {
    return Base
      .get('/otherproducts/available')
      .then(res => res.data)
      .then(res => res.reduce(function(acc, product) {
        const key = product.partNumber.replace(/-/g, '').toUpperCase();

        const accessory = accessoryMap[key] || {};
        acc[key] = { ...product, ...accessory };
        return acc;
      }, {}))
  }
}
